export enum TrackingMethod {
  EDI = 1
}

export enum Source {
  Manual = 1,
  Scan = 2
}

export enum DateFilterType {
  Today = 1,
  SpecificDate = 2,
  DateRange = 3
}

export enum BidStatus {
  Unknown = 0,
  Invited = 1,
  Submitted = 2,
  UnderReview = 3,
  Awarded = 4,
  Rejected = 5,
  Withdrawn = 6,
  Expired = 7
}

export enum ContestStatus {
  Unknown = 0,
  Open = 1,
  Closed = 2,
  Cancelled = 3,
  Awarded = 4,
  Expired = 5
}

export enum InvoiceMethod {
  Select = 0,
  Edi = 1,
  Api = 2,
  Email = 3
}

export enum BillingDays {
  '15Days' = 1,
  '30Days' = 2,
  '45Days' = 3,
  '60Days' = 4
}

export enum CostInvoiceStatus {
  Draft = 0,
  Received = 1,
  Approved = 2,
  Rejected = 3
}
